import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import type { PreCompraFormValues } from '../../components/pre-compras/pre-compra.schema';
import PreCompraForm from '../../components/pre-compras/PreCompraForm';
import { useCorralesStore } from '../../stores/corrales/corrales.store';
import type { PreCompraBusqueda } from '../../stores/pre-compras/pre-compra';
import {
  usePreComprasStore,
  type ActualizarPreCompraRequest
} from '../../stores/pre-compras/pre-compra.store';
import { useTiposGanadoStore } from '../../stores/tipos-ganado/tipos-ganado.store';
import { useZonasStore } from '../../stores/zonas/zonas.store';

const EditarPreCompra = () => {
  const id = useParams<{ id: string }>().id ?? '';
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const {
    current: precompra,
    actualizar,
    cancelar,
    cargarPorId,
    historialSiiniga,
    historialTemporal,
    cargarHistorialSiiniga,
    cargarHistorialTemporal
  } = usePreComprasStore();
  const { actives: tiposGanado, cargarActivos: cargarTiposGanado } = useTiposGanadoStore();
  const { actives: corrales, cargarActivos: cargarCorrales } = useCorralesStore();
  const { actives: zonas, cargarActivas: cargarZonas } = useZonasStore();

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
    cargarTiposGanado();
    cargarCorrales();
    cargarZonas();
  }, [id]);

  const handleSave = async (values: PreCompraFormValues) => {
    const request: ActualizarPreCompraRequest = {
      fecha: values.fecha.toDate(),
      idCorral: values.idCorral,
      idPersonaEntrega: values.idPersonaEntrega,
      idPersonaRecibe: values.idPersonaRecibe,
      idPersonaVende: values.idPersonaVende,
      totalAnimales: values.totalAnimales,
      referencia: values.referencia,
      partidas: values.animales.map((a) => ({
        partida: a.partida,
        areteSiiniga: a.areteSiiniga,
        areteTemporal: a.areteTemporal,
        tienePapeles: a.tienePapeles,
        reemo: a.reemo,
        idTipoGanado: a.idTipoGanado,
        kgCompra: a.kgCompra,
        kgLlegada: a.kgLlegada
      }))
    };
    await actualizar(id, request);
    return false;
  };

  const handlePreCompraSelect = (precompra: PreCompraBusqueda) => {
    const index = pathname.lastIndexOf('/');
    const basePath = pathname.substring(0, index);
    navigate(`${basePath}/${precompra.folioInterno}`);
  };

  const handleAdd = async () => {
    const index = pathname.lastIndexOf('/');
    const basePath = pathname.substring(0, pathname.lastIndexOf('/', index - 1));
    await navigate(`${basePath}/registrar`);
  };

  const handleCancel = async () => {
    await cancelar(id);
  };

  return (
    <PreCompraForm
      precompra={precompra}
      tiposGanado={tiposGanado}
      corrales={corrales}
      historialSiiniga={historialSiiniga}
      historialTemporal={historialTemporal}
      zonas={zonas}
      cargarHistorialSiiniga={cargarHistorialSiiniga}
      cargarHistorialTemporal={cargarHistorialTemporal}
      onAdd={handleAdd}
      onSave={handleSave}
      onCancel={handleCancel}
      onPreCompraSelected={handlePreCompraSelect}
    />
  );
};

export default EditarPreCompra;
